import React from 'react';

// Add the published store URLs here when the apps go live.
// Leaving a URL blank automatically shows a disabled "Coming Soon" button.
const IOS_APP_STORE_URL = '';
const ANDROID_APP_STORE_URL = '';

function StoreButton({ href, children, extraClass = '' }) {
  const className = `mobile-app-landing__store-button${extraClass ? ` ${extraClass}` : ''}`;

  if (href) {
    return (
      <a
        className={className}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={`${className} is-disabled`}
      type="button"
      disabled
    >
      {children} — Coming Soon
    </button>
  );
}

function MobileAppLanding({ platform, onContinue }) {
  const isAndroid = platform === 'android';

  return (
    <main className="mobile-app-landing">
      <section className="mobile-app-landing__card">
        <img
          className="mobile-app-landing__logo"
          src="/images/mysimpledb-logo.png"
          alt="MySimpleDB"
        />

        <div className="mobile-app-landing__eyebrow">
          Mobile apps coming soon
        </div>

        <h1 className="mobile-app-landing__title">
          MySimpleDB mobile app
        </h1>

        <p className="mobile-app-landing__message">
          For the best user experience, download the MySimpleDB mobile app.
          It will be available free for both iOS and Android.
        </p>

        <div className="mobile-app-landing__availability">
          Available for iOS and Android
        </div>

        <StoreButton href={IOS_APP_STORE_URL}>
          Download the iOS App on the App Store
        </StoreButton>

        <StoreButton
          href={ANDROID_APP_STORE_URL}
          extraClass="mobile-app-landing__store-button--second"
        >
          Get the Android App on Google Play
        </StoreButton>

        <button
          className="mobile-app-landing__continue"
          type="button"
          onClick={onContinue}
        >
          Continue to Website
        </button>

        <p className="mobile-app-landing__note">
          You can still use the website on your phone if you prefer.
        </p>
      </section>
    </main>
  );
}

export default MobileAppLanding;
